import {dateFormatter, getCountryCode} from '../../utils/util';
export const defaultContractCount = 5;
export const CALENDAR_YEAR = 'CALENDAR_YEAR';
export const T_MONTHS = 'T_MONTHS';
export const colorPalette = [
  'rgba(54, 124, 43, 1)',
  'rgba(105, 158, 97, 1)',
  'rgba(153, 189, 147, 1)',
  'rgba(187, 211, 183, 1)',
  'rgba(210, 225, 207, 1)',
];

export const months = {
  en: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ],
  es: [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
  ],
  de: [
    'Jan',
    'Feb',
    'März',
    'Apr',
    'Mai',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dez',
  ],
  pt: [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez',
  ],
};
export const currentYear = new Date().getFullYear();
export const currentMonth = new Date().getMonth();
const getMonthIndex = (date) => new Date(date).getMonth();
const getYear = (date) => new Date(date).getFullYear();

export const formatRawtData = (rawData, chartMode) => {
  let formattedrawData = {};
  let totalInstalmentCount = 0;
  let totalInstallmentAmount = 0;
  for (const [contractNo] of Object.entries(rawData)) {
    let data = rawData[contractNo];
    let currentYearInstallments = data[currentYear] ? data[currentYear] : [];
    let currentData;
    if (chartMode === CALENDAR_YEAR) {
      currentData = currentYearInstallments;
    } else {
      let nextYearInstallments = data[+currentYear + 1]
        ? data[+currentYear + 1]
        : [];
      currentData = [...currentYearInstallments, ...nextYearInstallments];
    }
    let {monthlyInstallments, instalmentCount, installmentAmount} =
      formatContractWise(currentData, chartMode);
    formattedrawData[contractNo] = monthlyInstallments;
    totalInstalmentCount = totalInstalmentCount + instalmentCount;
    totalInstallmentAmount = totalInstallmentAmount + installmentAmount;
  }
  return {formattedrawData, totalInstalmentCount, totalInstallmentAmount};
};
export const formatContractWise = (currentData, chartMode) => {
  const country_code = getCountryCode();
  let monthlyInstallments = {};
  let instalmentCount = 0;
  let installmentAmount = 0;
  currentData.forEach((perMonth) => {
    if (
      chartMode === CALENDAR_YEAR ||
      (currentYear === getYear(perMonth.paymentDueDate) &&
        currentMonth <= getMonthIndex(perMonth.paymentDueDate)) ||
      (currentYear + 1 === getYear(perMonth.paymentDueDate) &&
        currentMonth > getMonthIndex(perMonth.paymentDueDate))
    ) {
      monthlyInstallments[
        months[country_code][getMonthIndex(perMonth.paymentDueDate)] +
          ' ' +
          (getYear(perMonth.paymentDueDate) % 100)
      ] = perMonth.installmentAmount;
      instalmentCount++;
      installmentAmount = +installmentAmount + perMonth.installmentAmount;
    }
  });
  return {
    monthlyInstallments,
    instalmentCount,
    installmentAmount,
  };
};
export const get12MonthCalendar = (monthInYear) => {
  const country_code = getCountryCode();
  const currentMonth = new Date().getMonth();
  const monthNames = [];
  const currentYear = new Date().getFullYear() % 100;

  for (let i = 0; i < monthInYear; i++) {
    if (currentMonth + i > 11) {
      monthNames.push(
        months[country_code][currentMonth + i - 12] + ' ' + (currentYear + 1)
      );
    } else {
      monthNames.push(
        months[country_code][currentMonth + i] + ' ' + currentYear
      );
    }
  }
  return monthNames;
};
export const getLabels = (chartMode) => {
  let labels = [];
  const country_code = getCountryCode();
  const isMobile = window.innerWidth <= 768;
  if (chartMode === T_MONTHS) {
    labels = get12MonthCalendar(isMobile ? 6 : 12);
  } else {
    labels = isMobile ? months[country_code].slice(0, 6) : months[country_code];
    const temp = [];
    const currentYear = new Date().getFullYear() % 100;
    for (const obj of labels) {
      temp.push(obj + ' ' + currentYear);
    }
    labels = temp;
  }
  return labels;
};
export const getMonthlyInstallment = (records, chartMode) => {
  let result = {};
  let monthlyInstallmentCount = getLabels(chartMode).reduce((obj, month) => {
    obj[month] = 0;
    return obj;
  }, {});
  let monthlyInstallment = getLabels(chartMode).reduce((obj, month) => {
    obj[month] = 0;
    return obj;
  }, {});
  for (const [contractNo] of Object.entries(records)) {
    for (const [installmentMonth] of Object.entries(records[contractNo])) {
      monthlyInstallment[installmentMonth] =
        +monthlyInstallment[installmentMonth] +
        +records[contractNo][installmentMonth];
      records[contractNo][installmentMonth] &&
        ++monthlyInstallmentCount[installmentMonth];
    }
  }
  result = {monthlyInstallment, monthlyInstallmentCount};
  return result;
};
export const getContractInstallment = (singleRecord, chartMode) => {
  const result = getLabels(chartMode).map((month) =>
    singleRecord[month] === undefined ? null : singleRecord[month]
  );
  return [...result];
};
export const getDueDateForGraph = (schedules, monthIndex) => {
  let dueDate = '';
  schedules.forEach((installment) => {
    let dueMonth = new Date(installment.paymentDueDate).getMonth();
    if (dueMonth == monthIndex) {
      dueDate = dateFormatter(installment.paymentDueDate);
    }
  });
  return dueDate;
};
